import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import "../../wepcg/sidebar/css/wepcg_bar.css"

class BackendDisbursementBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Backend Disbursement</strong></h1>
            <p>
                This claim type is used for Growth Investment Program.
            </p>
            <p>
                Please fill in the required information and insert a comment to support your claim request.
            </p>
            <p>
                Contact details will be used in case additional justification from your side is needed.
            </p>
        </div>
    }
}

export default BackendDisbursementBar;